import React, { useState, useEffect } from 'react';
import { getStories } from '../services/api';
import StoryCard from '../components/StoryCard';
import { FileText } from 'lucide-react';

const Articles = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        const data = await getStories('article');
        setArticles(data);
      } catch (error) {
        console.error('Error fetching articles:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchArticles();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <p className="text-gray-600">Loading...</p>
      </div>
    );
  }
  return (
    <div className="py-16 px-6">
      <div className="max-w-4xl mx-auto">
        <div className="mb-16 text-center">
          <div className="flex items-center justify-center gap-3 mb-4">
            <FileText size={32} className="text-gray-900" />
            <h1 className="text-4xl md:text-5xl font-serif text-gray-900">Articles</h1>
          </div>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed">
            Essays on writing, creativity, and the practice of making meaning
            through words in a world that often moves too fast.
          </p>
        </div>

        <div>
          {articles.map((article) => (
            <StoryCard key={article.id} story={article} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Articles;